module.exports = __webpack_public_path__ + "static/media/79.1331c38e.jpg";